import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { generateModulePath } from '@autopass-web/domain';

import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';
import { PromotionItems } from '../../component/item';
import { PromotionGroupLoading } from '../../component/loading';
import { HTMLRenderer } from '../../component/quill-html-renderer';
import usePromotionStore from '../../promotion-store';
import { NoCoupon } from '../promotion-detail';
import styles from './index.module.scss';

const PromotionGroup = () => {
  const store = usePromotionStore();
  const appStore = useAppStore();
  const navigate = useNavigate();
  const generatePath = generateModulePath(
    appStore.nextModule,
    appStore.basePath,
  );

  const { groupId } = useParams();

  const currentCollection =
    store.promotionCollections?.find((x) => x.id === groupId) ?? null;
  const promotionIds = currentCollection
    ? currentCollection.notEndPromotionIds
    : [];

  const promotions = store.rawData.filter((p) => {
    return promotionIds.includes(p.id);
  });

  useEffect(() => {
    analytics.promotion_group_pageView({ id: groupId });
    window.scrollTo(0, 0);
  }, [groupId]);

  useEffect(() => {
    store.fetchPromotions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GroupPage = () => {
    const Banner = () => {
      const isVideo = currentCollection?.imageUrl?.includes('mp4');
      if (isVideo) {
        let arr = currentCollection?.imageUrl.split('.');
        const ext = arr[arr.length - 1];
        return (
          <video
            autoPlay
            loop
            playsInline
            muted
            style={{ display: 'block', width: '100%' }}
          >
            <source src={currentCollection?.imageUrl} type={`video/${ext}`} />
          </video>
        );
      } else {
        return (
          <img src={currentCollection?.imageUrl} alt="item" draggable={false} />
        );
      }
    };
    return (
      <>
        <Banner />
        <div className={styles.block}>
          <img src="/assets/icon_star.svg" alt="icon-star" />
          <div className={styles.title}>{currentCollection?.title}</div>
          <HTMLRenderer
            className={styles.desc}
            dangerouslySetInnerHTML={{
              __html: currentCollection?.richTextDescription ?? '',
            }}
          />
        </div>
        <PromotionItems loading={store.loading} promotions={promotions} />
      </>
    );
  };

  const Content = () => {
    if (store.loading) return <PromotionGroupLoading />;

    if (currentCollection) {
      return <GroupPage />;
    } else {
      return <NoCoupon onClick={() => navigate(generatePath('/'))} />;
    }
  };

  return (
    <div className={styles['promotion-group']}>
      <Content />
    </div>
  );
};

export default PromotionGroup;
